import request from '@/utils/request'

// 配置列表（按分组查询）
export function sysConfigList(params) {
  return request({ url: '/api/sys-config/list', method: 'get', params })
}

// 获取某分组的键值对Map
export function sysConfigMap(group) {
  return request({ url: `/api/sys-config/map/${group}`, method: 'get' })
}

// 新增/更新配置项
export function sysConfigSave(data) {
  return request({ url: '/api/sys-config', method: 'post', data })
}

// 批量保存某分组配置
export function sysConfigBatchSave(group, remark, configs) {
  return request({ url: `/api/sys-config/batch/${group}`, method: 'post', params: { remark }, data: configs })
}

// 删除配置项
export function sysConfigDelete(id) {
  return request({ url: `/api/sys-config/${id}`, method: 'delete' })
}
